import React, { useContext, useState, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
import { Duration } from "luxon";
import { TimeContext, Countdown, Hero, AnalyticsContext } from "Components";
import { Layout, BodySection, Container } from "../Layout";

export const PreShow = ({ event }) => {
  const { time } = useContext(TimeContext);
  const { logLeadSubmission } = useContext(AnalyticsContext);

  const [eventFired, setEventFired] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const utm_source = params.get("utm_source");

  useEffect(() => {
    if (utm_source === "oauth" && !eventFired) {
      setEventFired(true);
      logLeadSubmission({ formPart: 0 });
    }
    // eslint-disable-next-line
  }, []);

  const timeToStart =
    time < event?.start &&
    Duration.fromMillis(event?.start - time).shiftTo(
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    );

  const timer = {
    label: event?.preShow?.countdownLabel ?? "Show Starts In",
    days: timeToStart.days,
    hours: timeToStart.hours,
    minutes: timeToStart.minutes,
    seconds: timeToStart.seconds,
  };

  return (
    <Layout
      // header
      showHeader
      // hero
      heroContent={<Hero heroContent={<Countdown {...timer} />} />}
      // heading
      heading={event?.preShow?.heading}
      subHeading={event.preShow?.subHeading}
      // main
      // noPadding
      // footer
      showFooter
    >
      <BodySection>
        <Container>
          <p>{ReactHtmlParser(event?.preShow?.body)}</p>
        </Container>
      </BodySection>
    </Layout>
  );
};
